/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Campus_2Inputs */

const en_gd_campus_2 = /** @type {(inputs: Gd_Campus_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three things must be green: sign-in works, data is saved, and other people's data stays private.`)
};

const id_gd_campus_2 = /** @type {(inputs: Gd_Campus_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiga hal wajib hijau: bisa masuk akun, data tersimpan, dan data orang lain tidak bocor.`)
};

/**
* | output |
* | --- |
* | "Three things must be green: sign-in works, data is saved, and other people's data stays private." |
*
* @param {Gd_Campus_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_campus_2 = /** @type {((inputs?: Gd_Campus_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Campus_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_campus_2(inputs)
	return en_gd_campus_2(inputs)
});